module.exports = __webpack_public_path__ + "static/media/upload_dnc.da4bf820.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/upload_dnc.svg
// module id = 2727
// module chunks = 0